// Pillows instantiation of the shared order-detail `.order-summary` render.
// The shared createOrderDetail factory (tsi-common-react) owns the markup; this
// module injects pillows' own OrderOffer component (site-specific SCSS/layout,
// imports from the pillows Checkout tree). Existing importers -- the thank-you
// and account order-detail document templates -- import `OrderDetail` from here
// unchanged.
import { createOrderDetail } from "tsi-common-react/src/apps/customer-account/OrderDetail/index";

import { OrderOffer } from "../../apps/checkout/OrderOffer";

export const OrderDetail = createOrderDetail({ OrderOffer });
